import {BaseConverter} from '../../base/converters/base-converter.converter';
import {ServiceModel} from '../models/service.model';
import {Service} from '../../shared/DTO/service';
import {CpaConverter} from './cpa.converter';
import {ExtensionConverter} from './extension.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class ServiceConverter extends BaseConverter<ServiceModel, Service> {

  constructor(private cpaConverter: CpaConverter, private extensionConverter: ExtensionConverter) {
    super();
  }

  convertToDto(model: ServiceModel): Service {
    if (!model) {
      return;
    }
    return {
      code: model.code,
      compositionProduct: model.compositionProduct,
      consumption: model.consumption,
      contractStatus: model.contractStatus,
      cpa: this.cpaConverter.convertToDtoList(model.cpa),
      description: model.description,
      expectedContract: model.expectedContract,
      extensions: this.extensionConverter.convertToDtoList(model.extensions),
      extensionsQuantity: model.extensionsQuantity,
      includedQuantity: model.includedQuantity,
      keepOnTrasformation: model.keepOnTrasformation,
      maxQuantity: model.maxQuantity,
      measurementUnit: model.measurementUnit,
      minQuantity: model.minQuantity,
      name: model.name,
      subscription: model.subscription,
      typology: model.typology,
      value: model.value,
      state: model.state
    };
  }

  convertToModel(dto: Service): ServiceModel {
    if (!dto) {
      return null;
    }
    let model: ServiceModel = new ServiceModel();

    model.code = dto.code;
    model.compositionProduct = dto.compositionProduct;
    model.consumption = dto.consumption;
    model.contractStatus = dto.contractStatus;
    model.cpa = this.cpaConverter.convertToModelList(dto.cpa);
    model.description = dto.description;
    model.expectedContract = dto.expectedContract;
    model.extensions = this.extensionConverter.convertToModelList(dto.extensions);
    model.extensionsQuantity = dto.extensionsQuantity;
    model.includedQuantity = dto.includedQuantity;
    model.keepOnTrasformation = dto.keepOnTrasformation;
    model.maxQuantity = dto.maxQuantity;
    model.measurementUnit = dto.measurementUnit;
    model.minQuantity = dto.minQuantity;
    model.name = dto.name;
    model.subscription = dto.subscription;
    model.typology = dto.typology;
    model.value = dto.value;
    model.state = dto.state;
    return model;
  }

}
